<template>
  <v-card
    color="grey lighten-4"
    light
  >
    <v-card-text>
      <content-section
        id="timeline"
        :title="detailed ? 'Career And Projects' : 'My Experiences'"
      >
        <template slot="actions">
          <!-- <div>
            <v-switch
              v-model="detailed"
              :label="detailed ? 'Detailed' : 'Summary'"
            />
          </div> -->
        </template>

        <v-timeline dense>
          <v-timeline-item
            v-for="(item, i) in orderedItems"
            :key="i"
            :icon="item.icon || ''"
            :class="{ transparent: item.transparent }"
            large
          >
            <template
              v-if="item.iconImage"
              v-slot:icon
            >
              <v-avatar class="bw">
                <img :src="publicPath(item.iconImage)">
              </v-avatar>
            </template>
            <template v-slot:opposite />
            <v-layout>
              <v-flex
                v-if="$vuetify.breakpoint.smAndUp"
                md1
                sm2
                align-self-center
              >
                <span>{{ item.year }}</span>
              </v-flex>
              <v-flex
                md11
                sm10
                xs12
              >
                <v-card class="elevation-1">
                  <v-card-title class="pb-0">
                    <div>
                      <p v-if="$vuetify.breakpoint.xsOnly">
                        {{ item.year }}
                      </p>
                      <h3>{{ item.title }}</h3>
                    </div>
                  </v-card-title>
                  <v-card-text>
                    <v-layout wrap>
                      <v-flex
                        :md7="!!item.image"
                        :md12="!item.image"
                        xs12
                      >
                        <div class="mr-1">
                          <span
                            v-if="item.text"
                            class="pre"
                          >{{ item.text }}</span>
                          <!-- eslint-disable vue/no-v-html -->
                          <div
                            v-else-if="item.html"
                            v-html="item.html"
                          />
                          <!-- eslint-enable vue/no-v-html -->
                        </div>
                      </v-flex>
                      <v-flex
                        v-if="item.image"
                        md5
                        xs12
                      >
                        <div class="mt-2">
                          <v-carousel
                            v-if="Array.isArray(item.image)"
                            hide-delimiters
                            :show-arrows="false"
                            :height="640"
                          >
                            <v-carousel-item
                              v-for="(citem, ci) in item.image"
                              :key="ci"
                              :src="publicPath(citem)"
                            />
                          </v-carousel>
                          <v-img
                            v-else
                            :max-height="item.imageHeight ? item.imageHeight : ''"
                            :src="publicPath(item.image)"
                          />
                        </div>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
          </v-timeline-item>
        </v-timeline>
      </content-section>
    </v-card-text>
  </v-card>
</template>

<script>
import ContentSection from '@/views/dark-template/content/Section'
export default {
  name      : 'Timeline',
  components: { ContentSection },
  data      : () => ({
    detailed: true,
    items   : [
      {
        transparent: false,
        year       : '2007',
        title      : '미디어솔루션(MediaSolution)',
        html       : `
          <p>
              2007.10 ~ 2010.12 (3년 3개월) - 병역특례 근무
          </p>
            <ul>
                <li>금융 관련 Kiosk SW개발(Money Group)</li>
                <li>학사 무인 증명 발급기 Kiosk SW개발(연세대, 한양대, 한국외대 등)</li>
                <li>BUS 안내 시스템 SW개발(BIS)</li>
                <li>CGV 씨네라이브 KIOSK SW개발</li>
            </ul>          
          `,
        iconImage: 'img/timeline/media-solution.png',
      },
      {
        transparent: false,
        year       : '2012',
        title      : '삼성 소프트웨어 멤버십(Samsung Software Membership)',
        html       : `
          <p>
              2012.10 ~ 2014.01
          </p>
          <p>
              강남 멤버십 22기 (2년)
          </p>
            <ul>
                <li>삼성 테크윈 기업 과제 2건</li>
                  <ul>
                    <li>칩 마운트 장비 raw 데이터를 xml로 변환하는 SW 개발</li>
                    <li>CCTV Camera를 활용한 원격 화상 프로그램</li>
                  </ul>                
                <li>창의 과제 3건</li>
                  <ul>
                    <li>S급 창의과제 입상</li>
                  </ul>
            </ul>          
          `,
        iconImage: 'img/timeline/samsung-software.png',
        image    : 'img/timeline/samsung-software_2.png',
      },
      {
        transparent: false,
        year       : '2014',
        title      : '삼성 테크윈 (현 한화테크윈)',
        html       : `
          <p>
              2014.01 ~ 2015.03
          </p>
          <p>
              카메라 SW개발팀
          </p>
            <ul>
              <li>모바일 뷰어 개발(외주 관리 업무)</li>
              <li>웹 뷰어 Plugin 개발(ActiveX, NPAPI)</li>
            </ul>          
          `,
        iconImage: 'img/timeline/samsung-techwin.png',
        // image    : 'img/timeline/samsung-software_2.png',
      },
      {
        transparent: false,
        year       : '2015',
        title      : '삼성 테크윈 (현 한화테크윈)',
        html       : `
          <p>
              2015.04 ~ 2016.10
          </p>
          <p>시큐리티 선행개발팀</p>
          <p><b>프로젝트명<br>Non-Plugin 카메라 웹뷰어 (Fragment MP4 적용)</b></p>
          <p><b>관련 기술</b><br>Fragment MP4, HTML5 Video, MSE, javascript, H264, RTP Depacketize</p>
          <p><b>주요내용</b><br>카메라 서버로부터 받은 H264 코덱 영상을 Fragment MP4 컨테이너를 사용하여 HTML5 Video를 통해 영상 재생이 가능하도록 구현</p>
          <p>
            <b>본인 구현 내용</b><br>
            <ul>
              <li>Encoding 된 H264 영상을 받아 클라이언트에서 InitSegment, MediaSegment 생성</li>
              <li>생성된 Segment를 MP4 Reader를 통해 분석, MSE(Media Source Extension)와 Video Tag 생성 관리</li>
              <li>JS Decoder를 이용한 영상 재생은 성능적인 한계가 있기 때문에, 고해상도 재생이 불가피한 상황을 해결, 서버에서 MP4를 생성하게 되면 모든 카메라의 Firmware를 업데이트해야 하는 상황을 클라이언트에 적용하여 호환성 해결</li>
              <li>특허 출원 1건 완료</li>
            </ul>
          </p>    
          `,
        iconImage: 'img/timeline/samsung-techwin.png',
      },
      {
        transparent: false,
        year       : '2016',
        title      : '삼성 테크윈 (현 한화테크윈)',
        html       : `
          <p>
              2016.07 ~ 2016.09
          </p>
          <p>WEB SW개발팀</p>
          <p><b>프로젝트명<br>Non-Plugin 카메라 웹 뷰어 (Web Worker 적용과 개선)</b></p>
          <p><b>관련 기술</b><br>WebWorker, H264/H265 Codec, ASM.JS</p>
          <p><b>주요내용</b><br>Web Worker를 이용하여 UI Interface (Main Thread)와 분리, Audio와 Video의 간섭을 해결</p>
          <p>
            <b>본인 구현 내용</b><br>
            <ul>
              <li>Video Webworker, Audio Webworker 구현, Video WebWorker에 depacketize, decoding, 구현, worker들을 관리할 수 있는 WorkerManager 구현</li>
              <li>하나의 파이프라인으로 적용되어 부하가 많은 디코딩으로 인한 음성 끊김 또는 과도한 UI 이벤트 발생되어 영상/음성 지연 등 서로 간섭되던 웹 뷰어에서 WebWorker 적용 하여 멀티 Thread로 동작되어 병렬처리가 가능하도록 적용.</li>
              <li>특허 출원 1건 완료</li>
            </ul>
          </p>    
          `,
        iconImage: 'img/timeline/samsung-techwin.png',
      },
      {
        transparent: false,
        year       : '2017',
        title      : '삼성 테크윈 (현 한화테크윈)',
        html       : `
          <p>
              2017.03 ~ 2017.05
          </p>
          <p>WEB SW개발팀</p>
          <p><b>프로젝트명<br>Non-Plugin 카메라 웹뷰어 (WebAssembly 적용)</b></p>
          <p><b>관련 기술</b><br>FFMPEG, Emscript, WebAssembly, ASM.JS</p>
          <p><b>주요내용</b><br>javascript 디코더로는 성능적으로 한계가 있어, 성능을 높일 수 있는 방법으로  WebAssembly을 적용</p>
          <p>
            <b>본인 구현 내용</b><br>
            <ul>
              <li>FFMPEG 디코더를 Emscript로 변환한 후 WAST -> WASM을 거쳐 WebAssembly를 지원하는 브라우저에 적용</li>
              <li>H265 코덱인 경우 HTML5 Video Tag에 지원되고 있지 않아, JS 디코더 성능에 의존될 수 밖에 없는 상황이였으나, WebAssembly를 적용하여 성능 향상되는 결과를 보임</li>
            </ul>
          </p>    
          `,
        iconImage: 'img/timeline/samsung-techwin.png',
      },
      {
        transparent: false,
        year       : '2014',
        title      : '삼성 테크윈 (현 한화테크윈)',
        html       : `
          <p>
              2014.01 ~ 2017.12 (3년 11개월)
          </p>       
          `,
        iconImage: 'img/timeline/samsung-techwin.png',
        // image    : 'img/timeline/samsung-software_2.png',
      },
      {
        transparent: false,
        year       : '2018',
        title      : '카카오',
        html       : `
          <p>
              2018.03 ~ 2019.01
          </p>
          <p>동영상 개발파트</p>
          <p><b>프로젝트명<br>카카오TV HTML5 동영상 플레이어 전사적 지원</b></p>
          <p><b>관련 기술</b><br>javascript, video tag, html, css</p>
          <p>
            <b>본인 구현 내용</b><br>
            <ul>
              <li>HTML5 동영상 플레이어 SDK 전사 지원</li>
              <li>플레이어 재생 지표를 위한 Player video Tracking 적용</li>
              <li>카카오/다음 서비스에 필요한 기술 지원 및 기능 구현</li>
              <li>VOD 플레이어 지원, 라이브 플레이어 지원</li>
            </ul>
          </p>            
          `,
        iconImage: 'img/timeline/kakao.png',
        image    : 'img/timeline/kakao_1.png',
      },
      {
        transparent: false,
        year       : '2018',
        title      : '카카오',
        html       : `
          <p>
              2018.07 ~ 2019.01
          </p>
          <p>동영상 개발파트</p>
          <p><b>프로젝트명<br>카카오TV HTML5 플레이어 로깅 & 지표 차트 작업</b></p>
          <p><b>관련 기술</b><br>javascript, video tag, html, css, Sentry, amChart</p>
          <p>
            <b>본인 구현 내용</b><br>
            <ul>
              <li>플레이어 클릭 지표를 위한 Player Click Tracking 적용</li>
              <li>플레이어 재생 지표를 위한 Player video Tracking 적용</li>
              <li>재생 차트, 성별, 연령별 차트 적용</li>
              <li>모니터링은 위한 로깅 서비스 Sentry 적용</li>
            </ul>
          </p>  
          `,
        iconImage: 'img/timeline/kakao.png',
        image    : 'img/timeline/kakao_chart2.png',
      },
      {
        transparent: false,
        year       : '2019',
        title      : '카카오',
        html       : `
          <p>
              2019.01 ~ 2019.04
          </p>
          <p>동영상 개발파트</p>
          <p><b>프로젝트명<br>카카오TV HTML5 플레이어 Seeking 섬네일 비디오 적용</b></p>
          <p><b>관련 기술</b><br>javascript, video tag, html, css</p>
          <p><b>주요내용</b><br>영상 인코딩시 낮은 FPS와 저해상도로 영상을 인코딩하여 플레이어 Seeking용으로 활용</p>
          <p>
            <b>본인 구현 내용</b><br>
            <ul>
              <li>섬네일용 비디오 영상을 플레이어에서 Seeking 할 때 섬네일 비디오로 사용하여 구현</li>
              <li>주 개발자로 특허 출원</li>
                <ul>
                <li>발명의 명칭 : 동영상 콘텐츠의 미리보기 동영상을 생성하여 제공하는 방법과 시스템</li>
                <li>출원번호(출원일) : 10-2020-0127444 (2020.09.29)</li>
                </ul>
            </ul>
          </p>  
          `,
        iconImage: 'img/timeline/kakao.png',
        image    : 'img/timeline/kakao_thumb.png',
      },
      {
        transparent: false,
        year       : '2019',
        title      : '카카오',
        html       : `
          <p>
              2019.01 ~ 2019.06
          </p>
          <p>동영상 개발파트</p>
          <p><b>프로젝트명<br>카카오TV HTML5 플레이어 Adaptive Streaming을 위한 플레이어 DASH 적용</b></p>
          <p><b>관련 기술</b><br>javascript, video tag, html, css, meg-dash, hls, shaka player, drm</p>
          <p><b>주요내용</b><br>네트워크 Bandwidth에 따른 자동 화질 변화를 위해 ShakaPlayer 적용하여 Dash 영상 지원되도록 구현</p>
          <p>
            <b>본인 구현 내용</b><br>
            <ul>
              <li>자동 화질 변화 기능을 추가하기 위해 전반적인 플레이어 업무 지원</li>
              <li>오픈 소스 적용을 위한 ShakaPlayer 플레이어 검토 및 DASH 적용</li>
              <li>QOE 데이터 수집을 위해 플레이어에서 측정하여 서버로 전송</li>
              <li>영상 DRM (widevine, fairplay, playready) 적용</li>
            </ul>
          </p>  
          `,
        iconImage: 'img/timeline/kakao.png',
      },
      {
        transparent: false,
        year       : '2020',
        title      : '카카오',
        html       : `
          <p>
              2020.01 ~ 2020.04
          </p>
          <p>동영상 개발파트</p>
          <p><b>프로젝트명<br>카카오TV HTML5 플레이어 광고 적용</b></p>
          <p><b>관련 기술</b><br>javascript, video tag, html, css, vmap, vast</p>
          <p><b>주요내용</b><br>영상 중간 미드롤 광고 적용</p>
          <p>
            <b>본인 구현 내용</b><br>
            <ul>
              <li>광고 스펙 검토 및 전체적인 프로젝트 리딩</li>
              <li>프리롤, 포스트롤 광고 유지보수</li>
              <li>미드롤 광고 신규 적용</li>
              <li>미드 배너 텍스트/이미지 광고 신규 적용</li>
              <li>vmap, vast 스펙에 맞춰 광고 적용</li>
              <li>google ima sdk 적용</li>
              <li>광고 플레이어 컨트롤 구현</li>
            </ul>
          </p>  
          `,
        iconImage: 'img/timeline/kakao.png',
        image    : 'img/timeline/kakao_2.png',
      },
      {
        transparent: false,
        year       : '2020',
        title      : '카카오',
        html       : `
          <p>
              2020.06 ~ 2020.12
          </p>
          <p>동영상 클라이언트 파트</p>
          <p><b>프로젝트명<br>카카오TV 모바일 웹 서비스</b></p>
          <p><b>관련 기술</b><br>javascript, vuejs, vuex, restful api</p>
          <p><b>주요내용</b><br>카카오M 오리지날 컨텐츠를 위한 카카오TV 모바일 웹 서비스</p>
          <p>
            <b>본인 구현 내용</b><br>
            <ul>
              <li>모바일 웹서비스 전체적인 메인 개발</li>
            </ul>
          </p>  
          `,
        iconImage: 'img/timeline/kakao.png',
        image    : 'img/timeline/kakao_4.png',
      },
      {
        transparent: false,
        year       : '2021',
        title      : '카카오',
        html       : `
          <p>
              2021.01 ~ 2021.07
          </p>
          <p>동영상 클라이언트 파트</p>
          <p><b>프로젝트명<br>카카오TV 모바일 웹 서비스 2.0</b></p>
          <p><b>관련 기술</b><br>javascript, vuejs, vuex, restful api, </p>
          <p><b>주요내용</b><br>카카오M 오리지날 컨텐츠를 위한 카카오TV 모바일 웹 서비스</p>
          <p>
            <b>본인 구현 내용</b><br>
            <ul>
              <li>모바일 웹서비스 전체적인 메인 개발</li>
              <li>모바일 웹서비스 채널 상세 페이지</li>
              <li>모바일 웹서비스 영상 상세 페이지</li>
              <li>모바일 웹서비스 공통 컴퍼넌트 개발</li>
            </ul>
          </p>  
          `,
        iconImage: 'img/timeline/kakao.png',
        image    : [
          'img/timeline/moore_1.png',
          'img/timeline/moore_2.png',
          'img/timeline/moore_3.png',
          'img/timeline/moore_4.png',
        ],
      },
      {
        transparent: false,
        year       : '2021',
        title      : '카카오',
        html       : `
          <p>
              2021.10 ~ 2021.11
          </p>
          <p>동영상 클라이언트 파트</p>
          <p><b>프로젝트명<br>HTML5 웹 플레이어 Web Socket 적용</b></p>
          <p><b>관련 기술</b><br>javascript, Web Socket </p>
          <p><b>주요내용</b><br>웹 소켓을 사용하여 서버와 플레이어 실시간 통신 적용</p>
          <p>
            <b>본인 구현 내용</b><br>
            <ul>
              <li>웹 소켓 Web API를 래핑하여 라이브러리 생성</li>
              <li>플레이어와 서버 통신 적용(예약 VOD / LIVE 기능)</li>
            </ul>
          </p>  
          `,
        iconImage: 'img/timeline/kakao.png',
      },
      {
        transparent: false,
        year       : '2022',
        title      : '카카오(카카오 엔터테인먼트)',
        html       : `
          <p>
              2022.04 ~ 2023.03
          </p>
          <p>영상 서비스 개발팀</p>
          <p><b>프로젝트명<br>HTML5 플레이어 / 서비스 개발</b></p>
          <p><b>관련 기술</b><br>Vuejs, Html, CSS, javascript, Web Components, lit, TypeScript </p>
          <p><b>주요내용</b><br></p>
          <p>
            <b>본인 구현 내용</b><br>
            <ul>
              <li>HTML5 플레이어 / 서비스 개발</li>
              <li>소녀 리:버스 프로젝트</li>
            </ul>
          </p>  
          `,
        iconImage: 'img/timeline/kakaoent.png',
        image    : 'img/timeline/enter.png',
      },
      {
        transparent: false,
        year       : '2023',
        title      : '카카오',
        html       : `
          <p>
              2023.04 ~ 2023.07
          </p>
          <p>동영상 개발 파트</p>
          <p><b>프로젝트명<br>AI 활용한 사내 서비스 개발</b></p>
          <p><b>관련 기술</b><br>chrome extension, OpenAI API, , tailwindCSS, VueJS </p>
          <p><b>주요내용</b>
            <br>크롬 익스텐션 & Chat GPT 공유 웹 서비스
            <br>OpenAPI를 활용한 <a href='https://ai-pbox.web.app' target='_blank'>아이들의 플레이 그라운드</a>
          </p>
          <p>
            <b>본인 구현 내용</b><br>
            <ul>
              <li>프로젝트 프론트엔드 개발 담당</li>
            </ul>
          </p>  
          `,
        iconImage: 'img/timeline/kakao.png',
      },
      {
        transparent: false,
        year       : '2023',
        title      : '카카오',
        html       : `
          <p>
              2023.04 ~ 2023.07
          </p>
          <p>동영상 개발 파트</p>
          <p><b>프로젝트명<br>숏폼 서비스 미리보기 적용</b></p>
          <p><b>관련 기술</b><br>Typescript, CSS, Html, VueJS(3.0), Pinia, Restful api </p>
          <p><b>주요내용</b>
            <br>카카오TV 숏폼 그리드 미리보기 개발
            <br>카카오TV 숏폼 스와이프 미리보기 개발
          </p>
          <p>
            <b>본인 구현 내용</b><br>
            <ul>
              <li>프로젝트 메인 개발 담당</li>
            </ul>
          </p>  
          `,
        iconImage: 'img/timeline/kakao.png',
        image    : ['img/timeline/shorts_1.png', 'img/timeline/shorts_2.png'],
      },
      {
        transparent: false,
        year       : '2024',
        title      : '카카오',
        html       : `
          <p>
              2023.12 ~ 현재
          </p>
          <p>광고 공통 개발</p>
          <p><b>프로젝트명<br>광고 공통모듈 개발</b></p>
          <p><b>관련 기술</b><br>Reactjs, React-query, Nextjs, Typescript, Javasciprt, tailwindCSS, Docker</p>
          <p><b>주요내용</b>
            <br>광고 공통 컴포넌트 개발
            <br>광고 공통 모듈 비즈월렛 개발
            <br>광고 광고주 어드민 개발
          </p>
          <p>
            <b>본인 구현 내용</b><br>
            <ul>
              <li>프로젝트 메인 개발 담당</li>
            </ul>
          </p>  
          `,
        iconImage: 'img/timeline/kakao.png',
        image    : 'img/timeline/bizwallet.png',
      },
    ],
    items_en: [
      {
        transparent: false,
        year       : '2007',
        title      : 'Project Development, Media Solution',
        html       : `
          <p>
              2007.10 ~ 2010.12
          </p>
          <p><b>Projects</b></p>
            <ul>
                <li>Kiosk software development for universities (automatic dispenser), financial institute (Money Group, USA), and CGV</li>
                <li>Bus guide system software development</li>
            </ul>          
          `,
        iconImage: 'img/timeline/media-solution.png',
      },
      {
        transparent: false,
        year       : '2017',
        title      : 'Web Software Development, Samsung Techwin',
        html       : `
          <p>
              2017.03 ~ 2017.05
          </p>
          <p><b>Implementation of Non-Plugin Camera Webviewer Fragment MP4 & WebWorker</b></p>
          <p>
            <li>Provided video player using HTML5 Video by using Fragment MP4 container & H264 Codec sent from camera server</li>
            <li>Separated UI Interface (Main Thread) using Web Worker and provided a solution to an interference between audio and video</li>
          </p>

          <p><b>Skills</b>
            <br>Fragment MP4, HTML5 Video, MSE, Javascript, H264, RTP Depacketize</p>          
          <p>
            <b>In charge of</b><br>
            <ul>
              <li>Creating InitSegment & MediaSegment on the client with encoded H264 videos</li>
              <li>Analyzing created segment through MP4 Reader and creating/managing MSE(Media Source Extension) & video tag</li>
              <li>Provided a solution to low resolution videos from JS Decoder by updating all firmware in the client when server created MP4</li>
              <li>Implementation of Video Webworker, Audio Webworker, depacketize, decoding, and WorkerManager</li>
            </ul>
          </p>   
          `,
        iconImage: 'img/timeline/samsung-techwin.png',
      },
      {
        transparent: false,
        year       : '2017',
        title      : 'Web Software Development, Samsung Techwin',
        html       : `
          <p>
              2017.03 ~ 2017.05
          </p>
          <p><b>Implementation of Non-Plugin Camera Webviewer ‘WebAssembly’</b></p>
          <p>Overcame functional disadvantage of Javascript Decoder with WebAssembly</p>
          <p><b>Skills</b>
            <br>Javasciprt, Canvas, FFMPEG, Emscript, WebAssembly, ASM.JS</p>          
          <p>
            <b>In charge of</b><br>
            <ul>
              <li>Transforming FFMPEG Decoder to Emscript then WAST to WASM to apply it to WebAssembly supporting browser</li>
              <li>Improvement of overall software function through WebAssembly by eliminating JS decoder, which does not support HTML5 Video Tag of H265 Codec</li>
            </ul>
          </p>   
          `,
        iconImage: 'img/timeline/samsung-techwin.png',
      },
      {
        transparent: false,
        year       : '2018',
        title      : 'Video Development, Kakao',
        html       : `
          <p>
              2018.03 ~ 2021.05
          </p>
          <p><b>Company-side support for Kakao and Daum of Kakao TV HTML5 Player</b></p>
          
          <p><b>Skills</b>
            <br>Javasciprt, html, css, video tag</p>          
          <p>
            <b>In charge of</b><br>
            <ul>
              <li>Supporting HTML5 Player SDK company wide</li>
              <li>Applying Player video Tracking for player indices</li>
              <li>Tech supporting for Kakao and Daum services</li>
              <li>Supporting VOD player and live player</li>
            </ul>
          </p>            
          `,
        iconImage: 'img/timeline/kakao.png',
        image    : 'img/timeline/kakao_1.png',
      },
      {
        transparent: false,
        year       : '2018',
        title      : 'Video Development, Kakao',
        html       : `
          <p>
              2018.07 ~ 2019.01
          </p>
          <p><b>Player Logging & Charting for Kakao TV HTML5 Player</b></p>
          <p>Provided tracking and charting  to be used in various indexes related to player</p>
          <p><b>Skills</b>
            <br>Javasciprt, Chart, Sentry, amChart</p>          
          <p>
            <b>In charge of</b><br>
            <ul>
              <li>Applying Player Click Tracking</li>
              <li>Applying Player video Tracking</li>
              <li>Providing charting of players by user, gender, and age</li>
              <li>Implementing a logging service Sentry for monitoring</li>
            </ul>
          </p>   
          `,
        iconImage: 'img/timeline/kakao.png',
        image    : 'img/timeline/kakao_chart2.png',
      },
      {
        transparent: false,
        year       : '2019',
        title      : 'Video Development, Kakao',
        html       : `
          <p>
              2019.01 ~ 2019.04
          </p>
          <p><b>Implementation of Seeking Thumbnail Video on Kakao TV HTML5 Player</b></p>
          <p>Encoded low FPS and low resolution video to use it as player seeking purpose</p>
          <p><b>Skills</b>
            <br>Javascript, CSS, Html, Video tag</p>          
          <p>
            <b>In charge of</b><br>
            <ul>
              <li>Implementing a thumbnail video to show during user seeking process</li>
              <li>Commercialization of patented technology as a lead developer
                <ul>
                  <li>Patent name : Method and system for generating and providing a preview video of video content</li>
                  <li>Patent number(Patent date) : 10-2020-0127444 (2020.09.29)</li>
                </ul>
              </li>
            </ul>
          </p>  
          `,
        iconImage: 'img/timeline/kakao.png',
        image    : 'img/timeline/kakao_thumb.png',
      },
      {
        transparent: false,
        year       : '2019',
        title      : 'Video Development, Kakao',
        html       : `
          <p>
              2019.01 ~ 2019.06
          </p>
          <p><b>Player DASH Implementation for Adaptive Streaming on Kakao TV HTML5 Player</b></p>
          <p>Provided Dash video through ShakaPlayer for automatic resolution change depending on network bandwidth</p>
          <p><b>Skills</b>
            <br>Javasciprt, Video tag, Mpeg-dash, shaka player</p>          
          <p>
            <b>In charge of</b><br>
            <ul>
              <li>Supporting overall player to implement automatic resolution change</li>
              <li>Analysis of player for application of open source ShakaPlayer</li>
              <li>Implemented DASH function by application of open source ShakaPlayer</li>
              <li>Measuring collected QOE data on player level and sending to a server</li>
            </ul>
          </p>  
          `,
        iconImage: 'img/timeline/kakao.png',
      },
      {
        transparent: false,
        year       : '2020',
        title      : 'Video Client, Kakao',
        html       : `
          <p>
              2020.01 ~ 2020.04
          </p>
          <p><b>Launch of mid-roll ads on Kakao TV HTML5 Player</b></p>
          <p>Provided a mid-roll commercial for Kakao TV SMR videos based on company’s ad policy</p>
          <p><b>Skills</b>
            <br>Javascript, CSS, Html, Video tag, Restful api, vmap, vast</p>          
          <p>
            <b>In charge of</b><br>
            <ul>
              <li>Leading overall project and reviewing ad specs</li>
              <li>Implementing mid-roll per vmap & vest spec</li>
              <li>Creating ad player control</li>
            </ul>
          </p>   
          `,
        iconImage: 'img/timeline/kakao.png',
        image    : 'img/timeline/kakao_2.png',
      },
      {
        transparent: false,
        year       : '2020',
        title      : 'Video Client, Kakao',
        html       : `
          <p>
              2020.06 ~ 2020.12
          </p>
          <p><b>Kakao TV Mobile Web Service 1.0</b></p>
          <p>Developed a Kakao TV mobile web service for Kakao M’s original content</p>
          <p><b>Skills</b>
            <br>Javascript, CSS, Html, Vue, Vuex, Restful api, swiperJS, oAuth, Sentry</p>          
          <p>
            <b>In charge of</b><br>
            <ul>
              <li>Leading the project development </li>
              <li>Implementing state management through Vuex</li>
              <li>Creating debugging environment
                <ul>
                  <li>Applying a debugging tool for hard-to-inspect areas</li>
                  <li>Providing a log in service using Sentry</li>
                </ul>
              </li>
            </ul>
          </p>  
          `,
        iconImage: 'img/timeline/kakao.png',
        image    : 'img/timeline/kakao_4.png',
      },
      {
        transparent: false,
        year       : '2021',
        title      : 'Video Client, Kakao',
        html       : `
          <p>
              2021.01 ~ 2021.07
          </p>
          <p><b>Kakao TV Mobile Web Service 2.0</b></p>
          <p>Developed a Kakao TV mobile web service for Kakao M’s original content</p>
          <p><b>Skills</b><br>Javascript, CSS, Html, Vue, Vuex, Restful api, Sentry, Kakao SDK</p>          
          <p>
            <b>In charge of</b><br>
            <ul>
              <li>Leading the project development</li>
              <li>Developing detailed content pages</li>
              <li>Developing common service components </li>
            </ul>
          </p>  
          `,
        iconImage: 'img/timeline/kakao.png',
        image    : [
          'img/timeline/moore_1.png',
          'img/timeline/moore_2.png',
          'img/timeline/moore_3.png',
          'img/timeline/moore_4.png',
        ],
      },
      {
        transparent: false,
        year       : '2022',
        title      : 'Video Client, Kakao(Kakao Entertainment)',
        html       : `
          <p>
              2022.04 ~ 2022.03
          </p>
          <p><b>Kakao TV Mobile Web Service 2.0</b></p>
          <p>Developed a Kakao TV mobile web service for Kakao M’s original content</p>
          <p><b>Skills</b><br>Javascript, CSS, Html, Vue, Vuex, Restful api, Sentry, Kakao SDK</p>          
          <p>
            <b>In charge of</b><br>
            <ul>
              <li>HTML5 Player / Service Development</li>
              <li>Girl's Re:verse Project</li>
            </ul>
          </p>  
          `,
        iconImage: 'img/timeline/kakaoent.png',
      },
    ],
  }),
  computed: {
    orderedItems () {
      const langItems = this.language !== 'en' ? this.items : this.items_en

      const items = [...langItems].reverse()
      if (this.detailed) return items
      return items.filter((item) => {
        return !item.detailed
      })
    },
    language () {
      return this.$route.params.lang
    },
  },
}
</script>

<style scoped>
  .title {
    border-bottom: 2px #bfbfbf solid;
    line-height: 1.5 !important;
  }
  .pre {
    white-space: pre;
  }
  .transparent {
    opacity: 0.6;
  }
  .bw {
    background-color: white;
  }
</style>
